
export const brandName = 'REAL<span class="text-orange-500">RISES</span>';
export const brandNamePlain = 'RealRises';
export const heroTitle = 'Tap real estate equity to invest in Bitcoin & Tech.';
export const heroSubtitle1 = 'No money down, no monthly payments, no interest.';
export const heroSubtitle2 = 'A 5-year term that you can end early any time.';
export const heroDescription = `RealRises buys Bitcoin & Tech Equity with <span class="italic">our</span> money—you pay nothing. You get <strong>half the gain if it rises</strong>. If it falls, you <strong>cover the decline</strong>, secured by your real estate equity.`;
export const heroFootnote = '* Exit anytime <strong>with no penalty</strong>';
export const navigation = {
  howItWorks: 'How it Works',
  calculator: 'Calculator',
  faq: 'FAQ',
  aboutUs: 'About Us',
  getStarted: 'Get started'
};
export const introduction = {
  line1: 'REALRISES',
  line2: 'BITCOIN & TECH EQUITY \nInvestment PARTNERSHIP\n（BTIP）'
};
export const example = {
  title: 'Quick example',
  subtitle: 'RealRises BTIP in 3 steps',
  disclaimer: 'Example ignores 2% closing costs + 3rd-party fees. Calculator <strong>includes</strong> these costs.'
};
export const footer = {
  copyright: '© 2025 RealRises by A&J Global Co. All rights reserved.',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  disclaimer: 'RealRises is not a lender or investment adviser. All illustrations are hypothetical. Product terms subject to change. Not personalized investment advice.',
  riskWarning: 'Investments involve risk of loss, including foreclosure risk. For business/investment purposes only.',
  agreement: 'By using this site, you agree to our Terms and Privacy Policy.',
  madeWith: 'Made with'
};

export const faq = {
  title: 'FAQ',
  subtitle: 'Common questions about RealRises Bitcoin & Tech Equity Partnership',
  q1: 'How does RealRises work?',
  a1: 'We buy Bitcoin & Tech Equity with our capital—you pay nothing upfront. When it ends, you get 50% of gains. If it declines, you cover the loss (secured by home equity).',
  q2: 'What are the costs?',
  a2: 'No upfront costs or monthly payments. At closing: 2% partnership fee plus $3K-5K third-party costs. Can be rolled into existing mortgage.',
  q3: 'Can I exit early?',
  a3: 'Yes, exit anytime with no penalty. Complete flexibility.',
  q4: 'What if Bitcoin & Tech Equity drops?',
  a4: 'You cover the loss, secured by home equity. Primary residence cannot be foreclosed for partnership losses.',
  q5: 'How much exposure can I get?',
  a5: 'Typically $50K-500K based on your home equity and our risk assessment. Use our calculator for estimates.',
  q6: 'What are the requirements?',
  a6: 'Own U.S. real estate with sufficient equity. We evaluate credit, income, debt ratios, and property value.',
  q7: 'Is this a loan?',
  a7: 'No, it\'s an investment partnership. We share risks and rewards. No monthly payments or interest.',
  q8: 'What states is this available?',
  a8: 'Available in most U.S. states. Contact us to confirm availability in your area.',
  stillHaveQuestions: 'Questions? We\'re here to help.'
};

export const about = {
  ourMission: {
    title: 'Our Mission',
    description: 'To democratize access to Bitcoin and tech equity investments by leveraging homeowners\' real estate equity. We believe everyone should have the opportunity to participate in the digital economy without the traditional barriers of large capital requirements.'
  },
  ourValues: {
    title: 'Our Values',
    transparency: {
      title: 'Transparency',
      description: 'Clear terms, no hidden fees, and straightforward partnerships built on trust and open communication.'
    },
    innovation: {
      title: 'Innovation',
      description: 'Pioneering new financial products that bridge traditional real estate wealth with emerging digital assets.'
    },
    partnership: {
      title: 'Partnership',
      description: 'True partnerships where we share both risks and rewards, aligning our interests with yours.'
    }
  },
  ourLeadership: {
    title: 'Our Leadership',
    ariel: {
      title: 'Co-founder and CEO',
      description: 'Visionary leader with extensive experience in fintech and real estate. Ariel drives RealRises\' strategic direction and innovation in alternative investment solutions.'
    },
    kysen: {
      title: 'Co-founder and COO',
      description: 'Operations expert focused on scaling partnerships and ensuring seamless customer experience. Kysen oversees day-to-day operations and business development.'
    }
  }
};

export default {
  brandName,
  brandNamePlain,
  heroTitle,
  heroSubtitle1,
  heroSubtitle2,
  heroDescription,
  heroFootnote,
  navigation,
  introduction,
  example,
  footer,
  faq,
  about
};
